import Logistics from '../components/home/Logistics'
import Hero from '../components/service/hero'
import FAQ from '../components/home/FAQ'
import Contact from '../components/home/Contact'


function Services() {
  return (
    <div>
      <Hero />
      <Logistics />
      <FAQ />
      <Contact />
    </div>
  )
}

export default Services
